import { Component } from "@angular/core";
import { environment } from "../../../environments/environment";
import { DataService } from "../../_services/data.service";
import { AuthenticationService } from "../../_services/authentication.service";

@Component({
  moduleId: module.id,
  selector: "legacy-header-element",
  templateUrl: "legacy-header.component.html",
  styleUrls: ["legacy-header.component.scss"],
})
export class LegacyHeaderComponent {
  //   	@ViewChild('accessibility') accessibility: AccessibilityComponent;
  messages: any;
  siteId: any;
  isCollapsed: boolean = true;
  environment: any;
  public readonly showDemoLink: boolean =
    environment.name === "dev" || environment.name === "staging";

  constructor(
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
    this.authenticationService.siteId.subscribe((nextVal) => {
      this.siteId = nextVal;
    });
    this.environment = environment;
  }

  public menuClicked() {
    this.isCollapsed = !this.isCollapsed;
  }

  goToNoal() {
    window.open("https://noal.org.il/", "_blank");
  }

  goToMoshavim() {
    window.open("http://www.bmoshavim.co.il/", "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/app/header/legacyHeader/legacy-header.component.ts